<template>
  <v-container class="ma-0 pa-0">
    <v-row align="center" class="ma-0 pa-0">
      <v-col cols="1" class="ma-0 px-0 pb-0 pt-3 font-weight-bold">{{ dayWeek }}</v-col>
      <v-col >
        <v-radio-group v-model="dayInfo.operation" dense row hide-details :rules="[v => !!v]" class="ma-0">
          <v-radio label="운영" value="Enable"></v-radio>
          <v-radio label="운영 안함" value="Disable"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    <v-row class="ma-0 pa-0">
      <v-col cols="1" class="py-0 my-0"></v-col>
      <v-col class="py-0 my-0">
        <div>예약접수시간</div>
        <div>
          <c-time-picker
              :disabled="checkState(dayInfo.operation)"
              v-model="dayInfo.startResrv"
              :minute-interval="5"
              :h-range="[0,24]"
              :autoScroll="true"
              :defaultAutoScrollValue="7"
              inputWidth="100px"
          ></c-time-picker>
          <span class="px-2">~</span>
          <c-time-picker
              :disabled="checkState(dayInfo.operation)"
              v-model="dayInfo.endResrv"
              :minute-interval="5"
              :h-range="[0,24]"
              :autoScroll="true"
              :defaultAutoScrollValue="7"
              inputWidth="100px"
          ></c-time-picker>
        </div>
      </v-col>
      <v-col cols="6" class="py-0 my-0">
        <div>차량운행시간</div>
        <div>
          <c-time-picker
              :disabled="checkState(dayInfo.operation)"
              v-model="dayInfo.startDrive"
              :minute-interval="5"
              :h-range="[0,24]"
              :autoScroll="true"
              :defaultAutoScrollValue="7"
              inputWidth="100px"
          ></c-time-picker>
          <span>~</span>
          <c-time-picker
              :disabled="checkState(dayInfo.operation)"
              v-model="dayInfo.endDrive"
              :minute-interval="5"
              :h-range="[0,24]"
              :autoScroll="true"
              :defaultAutoScrollValue="7"
              inputWidth="100px"
          ></c-time-picker>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    dayInfo: {
      type: Object,
    },
  },
  data: () => ({
    openFlag: false,
  }),
  computed: {
    dayWeek() {
      switch(this.dayInfo.dayWeek) {
        case 0:
          return '일요일';
        case 1:
          return '월요일';
        case 2:
          return '화요일';
        case 3:
          return '수요일';
        case 4:
          return '목요일';
        case 5:
          return '금요일';
        case 6:
          return '토요일';
        case -1:
          return '평일';
        case -2:
          return '주말';
      }
    },
  },
  watch: {
    dayInfo(newVal) {
      if(newVal) {
        this.$emit( 'update:dayInfo', newVal)
      }
    },
  },
  methods: {
    checkState(value) {
      return value === 'Disable';
    }
  },
}
</script>

<style scoped>

</style>